export default class Modal {
    isOpen: boolean = false
    url: string | null = null
    width: number = 800
    height: number = 450
    header: string = 'Make a booking'

    hide (): this {
        this.isOpen = false

        return this
    }
}


// WEBPACK FOOTER //
// ./src/models/Modal.ts